import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { formatPrice } from "utils/formatPrice";

export type DeskCommService = {
  title?: string;
  price?: number;
  mechanic_notes?: string;
};

type ServicesProps = {
  title: string;
  services?: DeskCommService[];
  vat?: number;
};

export const Services = ({ title, services, vat }: ServicesProps) => {
  const { t } = useTranslation();

  if (!services?.length) return null;

  return (
    <div className="desk-comm-section-container">
      <div className="desk-comm-section-header">{title}</div>

      <Grid>
        <Grid.Column width={16}>
          <div className="services-header">
            <span>{t("v8_title", "Title")}</span>
            {services.some(s => s.price) && <span>{vat ? t("v8_price_inc_vat", "Price (incl. VAT)") : t("v8_price_excl_vat", "Price (excl. VAT)")}</span>}
          </div>
          {services.map((s, key) => (
            <div className="service" key={key}>
              <div className="service-title-remark-container">
                <span>{s.title}</span>
                <span>{s.mechanic_notes ?? ""}</span>
              </div>
              {!!s.price && (
                <div className="service-price-container">
                  <span>{formatPrice(vat ? s.price * (1 + vat / 100) : s.price)} €</span>
                </div>
              )}
            </div>
          ))}
        </Grid.Column>
      </Grid>
    </div>
  );
};
